import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { PanelStylesService} from './panel-styles.service';

@Component({
  selector: 'app-panel-styles',
  imports: [],
  templateUrl: './panel-styles.html',
  styleUrl: './panel-styles.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PanelStyles {
  protected panelStylesService = inject(PanelStylesService);

  protected onStyleChange(event: Event): void {
    const value = (event.target as HTMLSelectElement).value;
    this.panelStylesService.setSelectedStyle(value);
  }

  selectStyle(style: string) {
    this.panelStylesService.setSelectedStyle(style);
  }
}
